import { useAuth } from '@/features/auth/stores/auth.store'
import Page from '@/components/custom/Page'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { Button } from '@/shared/components/ui/button'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { WorkspaceLayout } from '@/features/workspace'
import { useCreateStoryMutation, useStoryQuery } from '../queries/story.queries'
import { StoryEntity } from '@/shared/lib/db'
import { toastService } from '@/shared/services/toast.service'

const AddStoryPage = () => {
    return (
        <WorkspaceLayout optionBar={<></>}>
            <AddStoryContent />
        </WorkspaceLayout>
    )
}

const AddStoryContent = () => {
    const { user } = useAuth()
    const { project } = useWorkspace()
    const router = useNavigate()
    const fileName = 'master'

    const { data: existingStory, isLoading } = useStoryQuery(project?.id, fileName)
    const createStoryMutation = useCreateStoryMutation({
        onSuccess: () => {
            toastService.success("Story created successfully")
            router(`/workspace/${project!.id}/story/`)
        },
        onError: (error) => {
            console.error('Failed to create story:', error)
            toastService.error("Failed to create story")
        }
    })

    const addStory = async () => {
        if (!project || !user) return

        const timestamp = new Date()
        const storyId = crypto.randomUUID()

        const storyData: StoryEntity = {
            id: storyId,
            content: [],
            created_at: timestamp,
            updated_at: timestamp,
            title: fileName,
            userId: user.uid,
            projectId: project.id,
        }

        await createStoryMutation.mutateAsync(storyData)
    }

    useEffect(() => {
        if (!project) return
        if (existingStory) {
            router(`/workspace/${project.id}/story/`)
        }
    }, [project, existingStory, router])

    return (
        <Page>
            <div className="flex flex-col items-center justify-center h-full">
                <h1 className="text-2xl font-bold mb-4">No Story Yet — Let’s Create One!</h1>
                <p className="text-gray-600 mb-6">
                    It looks like there’s no story for this project yet. Add your script to get
                    started and shape your story.
                </p>
                <Button
                    onClick={addStory}
                    className="cursor-pointer"
                    disabled={createStoryMutation.isPending || isLoading}
                >
                    {createStoryMutation.isPending ? 'Creating...' : 'Start Story'}
                </Button>
            </div>
        </Page>
    )
}

export default AddStoryPage
